import * as repo from '../repository/deliveryTemplateRepository';
import type { DeliveryTemplate } from '@/utils/templateParser';

/**
 * 사용자의 배송 템플릿 목록을 조회합니다.
 */
export const getTemplates = async (userId: string): Promise<DeliveryTemplate[]> => {
  return repo.getDeliveryTemplates(userId);
};

/**
 * 특정 배송 템플릿을 ID로 조회합니다.
 */
export const getTemplateById = async (userId: string, templateId: number): Promise<DeliveryTemplate | null> => {
  return repo.getDeliveryTemplateById(userId, templateId);
};

/**
 * 배송 템플릿을 생성합니다.
 */
export const createTemplate = async (
  userId: string,
  template: Pick<DeliveryTemplate, 'name' | 'columnMappings' | 'headerRowIndex'>,
): Promise<DeliveryTemplate> => {
  return repo.createDeliveryTemplate(userId, template);
};

/**
 * 배송 템플릿을 수정합니다.
 */
export const updateTemplate = async (
  userId: string,
  templateId: number,
  updates: Partial<Pick<DeliveryTemplate, 'name' | 'columnMappings' | 'headerRowIndex'>>,
): Promise<DeliveryTemplate> => {
  return repo.updateDeliveryTemplate(userId, templateId, updates);
};

/**
 * 배송 템플릿을 저장합니다 (id 유무로 생성/수정 분기).
 */
export const saveTemplate = async (
  userId: string,
  template: DeliveryTemplate,
): Promise<DeliveryTemplate> => {
  const payload = {
    name: template.name,
    columnMappings: template.columnMappings,
    headerRowIndex: template.headerRowIndex,
  };

  if (template.id) {
    return repo.updateDeliveryTemplate(userId, template.id, payload);
  }
  return repo.createDeliveryTemplate(userId, payload);
};

/**
 * 배송 템플릿을 삭제합니다.
 */
export const deleteTemplate = async (userId: string, templateId: number): Promise<void> => {
  return repo.deleteDeliveryTemplate(userId, templateId);
};
